import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import Venmo from "../../Components/Venmo/Venmo";
import { GetMyPackage, GetMyPackageApiCall } from "../../Redux/Auth/Auth_Action";

const VenmoRenewSubs = () => {
    const dispatch = useDispatch();
    const [state, setState] = useState();
    let params = new URLSearchParams(window.location.search);
    const Token = useSelector((state) => state.Auth.token);
    const getMyPackage = () => {
        let sendData = {
            subscription_id: params.get('id')
        }
        dispatch(GetMyPackageApiCall(Token, sendData))
            .then((res) => {
                console.log(res.data.response.data, '88888888888888888888888888');
                setState(res.data.response.data);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    useEffect(() => {
        getMyPackage();
    }, [])
    return (
        <div>
            <section className='profile my_subscription'>
                <Header />
                <div className='container px-4'>
                    <div className='row'>
                        <div className='col-lg-12 text-center'>
                            <p className='f-pop-bold f-43 mb-5 mt-3'>Renew Subscription</p>
                        </div>
                        {/* <div className='col-lg-4'>
                              <ProfileTab />
                            </div> */}
                        <div className='payment_component'>

                        </div>
                        <div className='col-lg-12 mb-5 res-pxx'>
                            <div className='row'>

                                <div className='col-lg-12'>
                                    <p className='f-pop-bold f-30 mb-4'>Payment Information</p>
                                    {/* <p className='f-mon-semibold f-20 mb-4 mt-4'></p> */}
                                    <p className='f-mon-semibold f-20 mb-4 mt-4'>
                                        Package Title
                                        <span className='mx-2'></span>
                                        :
                                        <span className='mx-2'></span>
                                        <span className='f-mon-bold clr-e0'>{state?.name}</span>
                                    </p>
                                    <p className='f-mon-semibold f-20 mb-4 mt-4'>
                                        Package Price
                                        <span className='mx-2'></span>
                                        :
                                        <span className='mx-2'></span>
                                        <span className='clr-e0 f-mon-bold clr-e0'>${state?.get_package?.price}</span>
                                    </p>
                                </div>
                                <div className="col-lg-12 mt-4">
                                    <Venmo props={{ price: state?.get_package?.price, slug: state?.get_package?.slug, interestsData: state?.getusers?.user_interest?.category, subscriptionId: params.get('id') }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default VenmoRenewSubs;